/**
 * Vehicle maintenance category values
 */
export enum VehicleMaintenanceRecordCategoryEnum {
	VEHICLE = 'vehicle',
	RENTAL_AGREEMENT = 'rental_agreement',
	VEHICLE_DAMAGE = 'vehicle_damage',
	VEHICLE_ROAD_WORTHY_CHECK = 'vehicle_road_worthy_check',
}
